import React from 'react';
import { uploadWidget } from "helpers";
import { ImageUploadButton } from "appStyles";

const ImageUpload = ({
  currentImage, 
  appId,
  uploadImage
}) => {
  
  const imageUrl = currentImage;
  const elementId = `${imageUrl}${appId}${Math.random()}`;

  return (
    <ImageUploadButton onClick={() => uploadWidget(uploadImage)}>
      + Add Main Image
    </ImageUploadButton>
  );
  // return (
  //   <div className={fileUpload}>
  //     <div>
  //       <label htmlFor={elementId} className={uploadMask}>Upload File</label>
  //       <input 
  //         id={elementId}
  //         placeholder='upload image'
  //         onClick={() => uploadWidget(uploadImage)}
  //         className={uploadInput}
  //       />
  //     </div>

  //     {imageUrl && <img className={imagePreview} src={imageUrl} alt=""/>}
  //     {imageUrl && 
  //       <div onClick={() => uploadImage(null)}>
  //         <span>Remove</span>
  //       </div>}
  //   </div>
  // );
};

export default ImageUpload;


// Backup file urls
// const imageLibrary = [
//   'https://media.mnn.com/assets/images/2016/05/trees-sleep.jpg.653x0_q80_crop-smart.jpg',
//   'https://cdn.shopify.com/s/files/1/0374/5581/products/SUN-0551_2048x.jpg?v=1497342497',
//   'https://previews.123rf.com/images/andiz/andiz1405/andiz140500200/28679024-spring-forrest-sunset-behind-the-trees-fresh-green-colors-rocks-and-trees-and-green-vegetation-on-th.jpg',
//   'https://cdn.mpora.com/embedded_full/5abad61816bdc.jpg',
//   'https://i.pinimg.com/originals/14/d8/26/14d8260aff7a3ae82c14ee3a20e213da.jpg',
// ];
// const backgroundUrl = imageLibrary[Math.floor(Math.random() * 3)];
